import { PointerEvent, ReactNode } from "react";
import { Pencil, Trash } from "lucide-react";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/shadcn/dropdown-menu";

// macOS ctrl+click is a primary press that opens the menu, so its release must not select an item.
const ignoreContextMenuRelease = (e: PointerEvent) => {
  if (e.button !== 0 || e.ctrlKey) e.preventDefault();
};

export const TagActionsMenu = ({
  open,
  onOpenChange,
  modal = false,
  onEdit,
  onDelete,
  children,
}: {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  modal?: boolean;
  onEdit: () => void;
  onDelete: () => void;
  children: ReactNode;
}) => (
  <DropdownMenu open={open} onOpenChange={onOpenChange} modal={modal}>
    <DropdownMenuTrigger asChild>{children}</DropdownMenuTrigger>
    <DropdownMenuContent
      className="w-32"
      align="end"
      side="right"
      onFocusOutside={(e) => e.preventDefault()}
      onContextMenu={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <DropdownMenuItem
        onPointerUp={ignoreContextMenuRelease}
        className="cursor-pointer"
        onClick={(e) => {
          e.stopPropagation();
          onEdit();
        }}
      >
        <Pencil className="mr-2 h-4 w-4" />
        Edit
      </DropdownMenuItem>
      <DropdownMenuItem
        onPointerUp={ignoreContextMenuRelease}
        className="cursor-pointer text-destructive focus:text-destructive"
        onClick={(e) => {
          e.stopPropagation();
          onDelete();
        }}
      >
        <Trash className="mr-2 h-4 w-4 text-destructive" />
        Delete
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);
